import { render } from "./ServicePill.vue?vue&type=template&id=52939ca5&scoped=true"
const script = {}

import "./ServicePill.vue?vue&type=style&index=0&id=52939ca5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52939ca5"

export default script